import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { NotificationsResponse } from "../interfaces/notifications.interface";

export const loadNotifications = createAction(
  "[Notifications] Load Notifications",
);

export const loadNotificationsSuccess = createAction(
  "[Notifications] Load Notifications Success",
  props<{response: NotificationsResponse}>(),
);

export const loadNotificationsError = createAction(
  "[Notifications] Load Notifications Error",
  props<{error: HttpErrorResponse}>(),
);

export const loadEventTypeLoadNotification = createAction(
  "[Notifications] Load Event Type LOAD Notification",
  props<{notificationId: string}>(),
);

export const loadEventTypeLoadNotificationSuccess = createAction(
  "[Notifications] Load Event Type LOAD Notification Success",
);

export const loadEventTypeDismissNotification = createAction(
  "[Notifications] Load Event Type DISMISS Notification",
  props<{notificationId: string}>(),
);

export const loadEventTypeDismissNotificationSuccess = createAction(
  "[Notifications] Load Event Type DISMISS Notification Success"
);